import { render } from "./AdminLeaveRecord.vue?vue&type=template&id=65337ad3"
import script from "./AdminLeaveRecord.vue?vue&type=script&lang=js"
export * from "./AdminLeaveRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__